<template>
  <div id="fuel-funds" class="fuel-funds h-margin-top-50 page__container--no-padding">
    <div v-if="isLoading" class="loading-indicator"></div>
    <FuelFundsSidebar></FuelFundsSidebar>
    <div class="fuel-funds__main">
      <div class="card-block">
        <FuelFundsCredits></FuelFundsCredits>
      </div>
      <div class="card-block h-mobile-margin-bottom-50">
        <FuelFundsTransactions></FuelFundsTransactions>
      </div>
    </div>
    <TermsModal></TermsModal>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import TermsModal from '../fuel-funds/TermsModal.vue';
  import FuelFundsSidebar from '../fuel-funds/FuelFundsSidebar.vue';
  import FuelFundsCredits from '../fuel-funds/FuelFundsCredits.vue';
  import FuelFundsTransactions from '../fuel-funds/FuelFundsTransactions.vue';

  export default {
    name: 'FuelFundsLayout',
    components: {
      TermsModal,
      FuelFundsSidebar,
      FuelFundsCredits,
      FuelFundsTransactions,
    },
    computed: {
      ...mapGetters('main', ['globalLoading']),
      isLoading() {
        return this.globalLoading;
      },
    },
    async mounted() {
      await this.$store.dispatch('fuelFunds/getFuelFunds');
      this.$store.dispatch('main/setProperty', { key: 'globalLoading', value: false });
    },
  };
</script>
